export type ServiceWorkerOutcome = "unsupported" | "disabled" | "registered" | "failed";

type Options = {
  env?: string;
  container?: ServiceWorkerContainer;
};

/**
 * Registers /sw.js in production builds. Outside production it instead
 * unregisters any leftover worker (e.g. from a local prod-build test on the
 * same origin) so dev HMR and e2e runs never fight a stale cache.
 */
export async function registerServiceWorker({
  env = process.env.NODE_ENV,
  container = typeof navigator === "undefined" ? undefined : navigator.serviceWorker,
}: Options = {}): Promise<ServiceWorkerOutcome> {
  if (!container) return "unsupported";
  try {
    if (env !== "production") {
      const registrations = await container.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
      return "disabled";
    }
    await container.register("/sw.js", { scope: "/", updateViaCache: "none" });
    return "registered";
  } catch {
    // A failed registration must never take the app down with it.
    return "failed";
  }
}
